import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { bibShape } from '@bibliocommons/bc-prop-types';

import ItemField from '../../shared/ItemField';

const renderFormat = (format) => {
  if (format) {
    return (
      <FormattedMessage id={`digiformat_${format.toLowerCase()}`} />
    );
  }

  return null;
};

const renderFileType = (format, size) => (
  <span>
    {renderFormat(format)}
    { format && size ? ' | ' : null}
    {size}
  </span>
);

export default function DigitalItemInfo({ bib, size, format }) {
  if (bib.getIn(['policy', 'materialType']) !== 'DIGITAL') {
    return null;
  }

  if (!size && !format) {
    return null;
  }

  return (
    <ItemField
      className="cp-digital-item-info"
      name={<FormattedMessage id="file_type" />}
      value={renderFileType(format, size)} />
  );
}

DigitalItemInfo.propTypes = {
  bib: bibShape,
  size: PropTypes.string,
  format: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/DigitalItemInfo/DigitalItemInfo.jsx